import { useState, useEffect } from "react";

const GOKAI = [
  { en: "Just for today, do not be angry", jp: "怒るな" },
  { en: "Just for today, do not worry", jp: "心配すな" },
  { en: "Just for today, be grateful", jp: "感謝して" },
  { en: "Just for today, work with diligence", jp: "業をはげめ" },
  { en: "Just for today, be kind to all living things", jp: "人に親切に" },
];

export const GokaiBanner = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % GOKAI.length), 4200);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="text-center py-2" data-testid="gokai-banner">
      <div className="font-jp text-gold/70 text-lg mb-1">{GOKAI[i].jp}</div>
      <div key={i} className="font-display text-2xl sm:text-3xl text-parchment/90 italic transition-opacity duration-700">
        {GOKAI[i].en}
      </div>
    </div>
  );
};

export { GOKAI };
